export default __webpack_public_path__ + "static/media/Аргачлал_2024.7b70a9b0.pptx";